import { get, writable } from "svelte/store";
import LoadState from "../../Enums/LoadState";
import GeoHelper from "../../Helpers/GeoHelper";
import MapStore from "../../Map/Store";
import BaseModel from "../../Models/BaseModel";
import HydrographicChartsStore from "./Store";

const HydrographicChartDataMapping = {
	name: "name",
	bounds: "bounds",
	size: "size",
	scale: "scale",
	bytes: "bytes"
};
class HydrographicChart extends BaseModel {
	constructor(feature, boundaryType) {
		super(HydrographicChartDataMapping, {
			name: "Unknown",
			bounds: [[0, 0], [10, 10]],
			size: [10, 10],
			scale: "Unknown",
			bytes: 0
		});

		this.data = feature;

		this.loadState = writable(LoadState.INIT);
		this.visible = writable(false);

		const coords = [this.bl, this.br, this.tr, this.tl, this.bl];
		this.boundsFeature = GeoHelper.featureLineString(coords);
		this.boundsFeature.properties = this.data;

		this.imageFeature = null;

		this.visible.subscribe((visible) => {
			if (visible && get(this.loadState) === LoadState.INIT) {
				HydrographicChartsStore.actions.loadSingle(this);
			}
			// else if (!visible && get(this.loadState) === LoadState.LOADED) {

			// }
		});
	}

	get name() {
		return this.get("name");
	}

	get scale() {
		return this.get("scale");
	}

	get bounds() {
		return this.get("bounds");
	}

	get file() {
		return this.get("file");
	}

	get br() { // right, bottom
		return [this.tr[0], this.bl[1]];
	}

	get tl() { // left, top
		return [this.bl[0], this.tr[1]];
	}

	get bl() {
		return this.bounds[0];
	}

	get tr() {
		return this.bounds[1];
	}

	get left() {
		return this.bl[0];
	}

	get right() {
		return this.tr[0];
	}

	get top() {
		return this.tr[1];
	}

	get bottom() {
		return this.bl[1];
	}

	get layerId() {
		return "hydrographic_chart_" + this.file;
	}

	set image(src) {
		this.imageFeature = GeoHelper.imageRect(src, [
			this.tl, // bl
			this.tr, // br
			this.br, // tr
			this.bl // tl
		]);

		const map = MapStore.helpers.getMap();
		map.addSource(this.layerId, this.imageFeature);
		map.addLayer({
			id: this.layerId,
			source: this.layerId,
			type: "raster",
			paint: {
				"raster-opacity": 1.0,
				"raster-resampling": "nearest"
			}
		}, "ukho_charts_borders");
	}

	asFeature() {
		return this.data;
	}
}

export default HydrographicChart;
